import React, { useState } from 'react';
import { Button, Alert, Box, Typography } from '@mui/material';
import { httpsCallable } from 'firebase/functions';
import { CloudFunctions } from '../FirebaseAuth/firebase';

/**
 * Admin utility component to generate AI summaries
 * Only visible to kwallAdmin users
 */
const AdminSummaryGenerator = ({ currentUser }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [result, setResult] = useState('');
  const [error, setError] = useState('');

  // Only show to kwallAdmin users
  if (!currentUser?.role?.includes('kwallAdmin')) {
    return null;
  }

  const handleGenerateSummaries = async () => {
    setIsGenerating(true);
    setError('');
    setResult('');

    try {
      const generateSummariesBatch = httpsCallable(CloudFunctions, 'aiSummaryGenerator-generateSummariesBatch');
      const response = await generateSummariesBatch({});
      
      setResult(response.data.message || 'Summaries generated successfully!');
    } catch (error) {
      console.error('Error generating summaries:', error);
      setError(error.message || 'Failed to generate summaries');
    }

    setIsGenerating(false);
  };



  return (
    <Box sx={{ mt: 2, p: 2, bgcolor: 'warning.light', borderRadius: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        Admin: AI Summary Generator
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      
      {result && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {result}
        </Alert>
      )}
      
      <Button
        variant="contained"
        color="warning"
        onClick={handleGenerateSummaries}
        disabled={isGenerating}
        size="small"
      >
        {isGenerating ? 'Generating...' : 'Generate AI Summaries for All Organizations'}
      </Button>
      
      <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary' }}>
        This will create AI summaries for all organizations, accounts, and sites. 
        Use this if AI Assistant shows "AI summary not yet generated" messages.
      </Typography>
    </Box>
  );
};

export default AdminSummaryGenerator;